// Mouseflow.tsx
import { useEffect } from 'react';

export default function Mouseflow() {
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      const script = document.createElement('script');
      script.src = '//cdn.mouseflow.com/projects/4b7b337d-d5bd-45c1-b335-0a349d2bd91b.js';
      script.type = 'text/javascript';
      script.defer = true;
      document.body.appendChild(script);
    }
  }, []);

  return null;
}
